export const EMAIL_NOTIFICATION_DEFAULTS = {
    pickedUp: false,
    canceled: true,
    notClaimed3d: true,
    dueToday: false,
    verifyDay8: false,
    confirmDay14: true,
    autoCancelDay21: true,
    freshReview: true,
    emailDigest: true,
    weeklyDigest: true,
};

export const EMAIL_NOTIFICATION_GROUPS = [
    {
        id: "assignments",
        title: "Assignment notifications",
        description: "Updates about assignment activity, deadlines, review verification, and completed reviews.",
        items: [
            {
                key: "pickedUp",
                title: "A reader has just picked up your assignment",
                description: "Sent when a reader starts working on one of your assignments.",
            },
            {
                key: "canceled",
                title: "A reader has canceled your assignment",
                description: "Sent when a reader cancels an assignment and provides a reason.",
            },
            {
                key: "notClaimed3d",
                title: "Your review offer has not been claimed in 3 days",
                description: "Sent when an open review offer has not received a reader yet.",
            },
            {
                key: "dueToday",
                title: "Your review is due today",
                description: "Reminder sent on the review due date.",
            },
            {
                key: "verifyDay8",
                title: "Time to verify your review",
                description: "Day 8 reminder after a review is turned in.",
            },
            {
                key: "confirmDay14",
                title: "Review confirmation needed",
                description: "Day 14 reminder after a review is turned in.",
            },
            {
                key: "autoCancelDay21",
                title: "Assignment canceled due to no review",
                description: "Day 21 notification when a review was not verified.",
            },
            {
                key: "freshReview",
                title: "A fresh new review just landed on your book",
                description: "Sent when Virtalibry detects a new review for your book or product.",
            },
        ],
    },
    {
        id: "digests",
        title: "Digest emails",
        description: "Marketing, product news, project updates, and book recommendations.",
        items: [
            {
                key: "emailDigest",
                title: "Email Digest",
                description: "News and project updates from Virtalibry.",
            },
            {
                key: "weeklyDigest",
                title: "Weekly Digest",
                description: "Personal weekly book recommendations.",
            },
        ],
    },
];

export const EMAIL_NOTIFICATION_KEYS = Object.keys(EMAIL_NOTIFICATION_DEFAULTS);

export const mergeEmailNotificationSettings = (settings = {}) => ({
    ...EMAIL_NOTIFICATION_DEFAULTS,
    ...(settings || {}),
});
